import { FlexColSm, Headline3 } from 'components/Elements';
import { ImageCard } from './FileCard';
import { ImageSelectionComponent } from './FileSelectionComponent';
import { FileDocument } from 'models/FileDocument';
import strings from '../../../strings/strings.json';
import { ResourcesContainer } from '../shared-styles/courseBuilderFormComponents';
import React from 'react';
import { SelectSlideImage } from './activityForms/presentationActivities/PresentationSlide';

type AddImageComponentProps = {
    image?: SelectSlideImage | null;
    setImage: (image: SelectSlideImage | null) => void;
    disableButtons: boolean;
};

export function AddImageComponent({ image, setImage, disableButtons }: AddImageComponentProps) {
    const addImageButtonRef = React.useRef<HTMLButtonElement>(null);
    const removeFileButtonRef = React.useRef<HTMLButtonElement>(null);

    const addImageFromLocal = (file: File | null | undefined) => {
        const previewUrl = URL.createObjectURL(file!);

        const newCreateImage: SelectSlideImage = {
            type: 'new',
            filePath: previewUrl,
            file: file!,
            imageDescription: '',
        };
        setImage(newCreateImage);
        if (!image) {
            addImageButtonRef.current?.focus();
        }
    };

    const addImageFromProvider = (file: FileDocument) => {
        const newCreateImage: SelectSlideImage = {
            type: 'existing',
            id: file.id,
            filePath: file.s3Filepath,
            fileName: file.filename,
        };
        setImage(newCreateImage);
        if (!image) {
            addImageButtonRef.current?.focus();
        }
    };

    const removeImage = () => {
        setImage(null);
        if (!image) {
            addImageButtonRef.current?.focus();
        }
    };

    return (
        <FlexColSm>
            <Headline3>{strings.selectFileForm.addImageComponentTitle}</Headline3>
            <ResourcesContainer>
                {!image ? (
                    <ImageSelectionComponent
                        setFileFromLocal={addImageFromLocal}
                        setFileFromProvider={addImageFromProvider}
                        setFileFromLocalMetaData={() => {}}
                        disableButton={disableButtons}
                        selectFileButtonRef={addImageButtonRef}
                    />
                ) : (
                    <ImageCard
                        fileName={image.type === 'existing' ? image.fileName : image.file?.name ?? ''}
                        removeFile={() => removeImage()}
                        disabled={disableButtons}
                        filePath={image.filePath}
                        imageDescription={''}
                        source={image.type === 'existing' ? 'provider' : 'local'}
                        removeFileButtonRef={removeFileButtonRef}
                    />
                )}
            </ResourcesContainer>
        </FlexColSm>
    );
}
